// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-light: #f4f9ff;
  --color-white: #ffffff;
  --color-primary: #1f68d6;
  --color-primary-2: #3b7ee3;
  --color-primary-3: #ccedff;
  --color-primary-4: #003c97;
  --color-primary-7: #c1daff;
  --color-primary-8: #97c1ff;
  --color-primary-9: #CCEDFF;
  --color-primary-10: #A8E1AE;
  --color-primary-11: #a1c4f9;
  --color-primary-12: #F5F5F5;
  --color-light-2: #E0E0E0;
  --color-error: #e12f2f;
  --color-success: #66b032;
  --color-green: #569755;
  --color-green-2: #92e391;
  --color-green-3: #d3eace;
  --color-yellow: #e7d788;
  --color-yellow-2: #ffc247;
  --color-yellow-3: #8f4f00;
  --color-light-red: #FFE8E8;
  --color-deep-red: #9f0000;
  --color-red: #c43c2d;
  --color-red-2: #af2415;
  --color-grey: #b3b3c5;
  --color-grey-2: #9898AB;
  --color-grey-3: #e0e9f3;
  --color-grey-4: #D1D1D1;
  --color-grey-5: #EBEBF5;
  --color-table-grey: #fafafc;
  --color-table-grey-1: #f4f4fc;
  --color-dark: #4a4a68;
  --color-dark-2: #1a1a42;
  --color-dark-3: #696365;
  --color-dark-4: #60607A;
  --color-dark-6: #2a2828;
  --color-admin: #112855;
  --color-admin-2: #071530;
  --color-admin-3: #020710;
  --color-disabled: #C0C0C0;
  --color-light-blue: #EBF2FF;
  --color-light-blue-2: #D4E5FF;
  --color-light-blue-3: #E7F3FE;
  --color-dark-yellow: #7E6E1F;
  --color-light-brown: #f4f5f6;
  --color-light-green: #E4FFEC;
  --color-light-yellow: #FFF5D7;
  --color-light-grey: #F3F3FF;
  --color-sell-main: #001432;
  --color-sell-2: #5F5F61;
  --color-moneyex-primary: #25C900;
  --color-moneyex-primary-2: #6bf04d;
  --color-moneyex-primary-3: #305627;
  --color-moneyex-primary-4: #0a2404;
  --default-font-size: 1.8rem;
  --default-font-h1: 6.4rem;
  --default-font-h2: 4rem;
  --default-font-h3: 3.2rem;
  --default-font-subtitle: 2.4rem;
  --default-font-medium: 1.6rem;
  --default-font-small: 1.4rem;
  --default-font-xsmall: 1.2rem;
}

.MimaInput_form__HrJaF {
  display: block;
}
.MimaInput_form__group__WVOmY:not(:last-child) {
  margin-bottom: 1rem;
}
.MimaInput_form__input__r5iYU {
  font-size: 1.8rem;
  font-family: inherit;
  color: var(--color-dark);
  padding-left: 2rem;
  width: 100%;
  height: 6rem;
  border-radius: 1rem;
  background-color: var(--color-white);
  border: 1px solid var(--color-dark);
  display: block;
  margin-top: 0.5rem;
}
.MimaInput_form__input__r5iYU:focus, .MimaInput_form__input__r5iYU:focus-visible, .MimaInput_form__input__r5iYU:focus-within {
  color: var(--color-dark);
  border: 1px solid #1f68d6;
}
.MimaInput_form__input_filter__zDB96 {
  font-size: var(--default-font-small);
  font-family: inherit;
  color: var(--color-dark);
  padding-left: 2rem;
  width: 100%;
  height: 4rem;
  border-radius: 1rem;
  background-color: var(--color-white);
  border: 1px solid var(--color-dark);
  display: block;
  margin-top: 0.5rem;
}
.MimaInput_form__input_filter__zDB96:focus, .MimaInput_form__input_filter__zDB96:focus-visible, .MimaInput_form__input_filter__zDB96:focus-within {
  color: var(--color-dark);
  border: 1px solid #1f68d6;
}
.MimaInput_form__label__FIG4x {
  font-size: 1.4rem;
  font-family: inherit;
  padding-left: 2rem;
  box-sizing: border-box;
  width: 38rem;
}
.MimaInput_form__calendar__BG5qm {
  font-family: inherit;
  font-size: 1.4rem;
  background-color: var(--color-white);
  color: var(--color-dark);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  border-radius: 1rem;
  border: none;
  width: 25rem;
  height: 27.5rem;
  display: inline-block;
  position: relative;
  box-sizing: border-box;
  padding: 5px;
}
.MimaInput_form__calendar__BG5qm > :nth-child(3) {
  background-color: var(--color-dark);
  left: 1rem;
  top: 1rem;
  border-radius: 0.8rem;
}
.MimaInput_form__calendar__BG5qm > :nth-child(3):hover {
  background-color: var(--color-primary-4);
}
.MimaInput_form__calendar__BG5qm > :nth-child(3) span::before {
  right: -0.3rem;
  top: 0.7rem;
}
.MimaInput_form__calendar__BG5qm > :nth-child(4) {
  background-color: var(--color-dark);
  right: 1rem !important;
  top: 1rem;
  border-radius: 0.8rem;
}
.MimaInput_form__calendar__BG5qm > :nth-child(4):hover {
  background-color: var(--color-primary-4);
}
.MimaInput_form__calendar__BG5qm > :nth-child(4) span::before {
  left: -0.3rem;
  top: 0.7rem;
}
.MimaInput_form__calendar__BG5qm > :nth-child(5) {
  width: 100%;
  font-family: "Montserrat";
  font-size: 1.4rem;
  background-color: var(--color-light);
}
.MimaInput_form__calendar__BG5qm > :nth-child(5) > :nth-child(1) {
  background-color: var(--color-primary-3);
}
.MimaInput_form__calendar__BG5qm > :nth-child(5) > :nth-child(1) > :nth-child(1) {
  font-size: 1.4rem;
  color: var(--color-primary);
}
.MimaInput_form__calendar__BG5qm > :nth-child(5) > :nth-child(1) > :nth-child(3) {
  font-weight: 700;
  color: var(--color-dark);
  display: grid;
  grid-template-columns: repeat(7, 1fr);
}
.MimaInput_form__calendar__BG5qm > :nth-child(5) > :nth-child(2) > :nth-child(even) {
  background-color: var(--color-primary-7);
}
.MimaInput_form__calendar__BG5qm > :nth-child(5) > :nth-child(2) > * {
  color: var(--color-dark);
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  height: 3rem;
}
.MimaInput_form__calendar__BG5qm > :nth-child(6) {
  font-family: "Montserrat";
  font-size: var(--default-font-small);
  position: absolute;
  right: -85px;
}
.MimaInput_form__calendar__BG5qm > :nth-child(6) > :nth-child(1) > * {
  font-size: var(--default-font-xsmall) !important;
}

.MimaInput_filled__lg89T {
  color: var(--color-dark);
}

.MimaInput_error__QkKJM {
  font-size: var(--default-font-small);
  color: var(--color-error);
  font-weight: 400;
  margin: 1rem 0;
  max-width: 38rem;
}

.MimaInput_note__rddKG {
  display: flex;
  align-items: center;
  font-size: var(--default-font-xsmall);
  color: var(--color-primary);
  font-weight: 400;
  margin: 1rem 0;
}

.MimaInput_pageCount__q1trw {
  font-size: var(--default-font-small);
  font-weight: 700;
  margin: 1rem 0;
  max-width: 38rem;
}

.MimaInput_success__h3__1dGfk {
  color: var(--color-success);
  font-size: var(--default-font-h3);
  font-weight: 700;
  line-height: 3.5rem;
}

.MimaInput_iconAlign__3NiB0 {
  max-height: 6rem;
  position: relative;
}
.MimaInput_iconAlign__3NiB0 > :nth-child(2) {
  position: absolute;
  left: 0;
}

.MimaInput_tag__HOPrF {
  background-color: var(--color-primary-3);
  font-size: var(--default-font-small);
  height: 4rem;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  width: 15rem;
  margin-top: 1rem;
  margin-right: 1rem;
}
.MimaInput_tag_close__CPSWl {
  display: block;
  background-color: var(--color-dark);
  color: var(--color-white);
  width: 16px;
  height: 16px;
  line-height: 16px;
  text-align: center;
  border-radius: 50%;
}

.MimaInput_tags__JdTMp {
  display: flex;
  flex-wrap: wrap;
}
.MimaInput_tags__JdTMp > :not(:last-child) {
  margin-right: 1rem;
}

.MimaInput_singleTag__G0kUc {
  display: flex;
  font-size: var(--default-font-small);
  align-items: center;
  background-color: var(--color-primary-3);
  padding: 0.5rem;
  border-radius: 0.5rem;
  cursor: pointer;
  margin-bottom: 0.5rem;
}
.MimaInput_singleTag__G0kUc > :not(:last-child) {
  margin-right: 0.5rem;
}
.MimaInput_singleTag__G0kUc:hover {
  color: var(--color-primary);
}

.MimaInput_suggestions__aMe2F {
  padding: 0.5rem;
  font-size: var(--default-font-small);
  cursor: pointer;
  background-color: var(--color-dark);
  border-radius: 0.5rem;
  color: var(--color-white);
}
.MimaInput_suggestions__all__1BQjb {
  display: flex;
  flex-wrap: wrap;
}
.MimaInput_suggestions__all__1BQjb > :not(:last-child) {
  margin-right: 0.5rem;
}

.MimaInput_dateInput__JI0Z8 {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/variables/_variables.scss","webpack://./src/assets/styles/MimaInput.module.scss"],"names":[],"mappings":"AAAA;EAEC,sBAAA;EACA,sBAAA;EAEA,wBAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,wBAAA;EAGA,sBAAA;EACA,wBAAA;EACA,sBAAA;EACA,wBAAA;EACA,wBAAA;EACA,uBAAA;EACA,yBAAA;EACA,yBAAA;EACA,0BAAA;EACA,yBAAA;EACA,oBAAA;EACA,sBAAA;EAEA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,2BAAA;EACA,6BAAA;EAEA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EAEA,sBAAA;EACA,wBAAA;EACA,wBAAA;EAEA,yBAAA;EACA,2BAAA;EACA,6BAAA;EACA,6BAAA;EAEA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;EACA,2BAAA;EACA,0BAAA;EACA,uBAAA;EAEA,gCAAA;EACA,kCAAA;EACA,kCAAA;EACA,kCAAA;EAKA,2BAAA;EACA,yBAAA;EACA,uBAAA;EACA,yBAAA;EACA,+BAAA;EACA,6BAAA;EACA,4BAAA;EACA,6BAAA;ACbD;;AA9DA;EACE,cAAA;AAiEF;AA/DE;EACE,mBAAA;AAiEJ;AA9DE;EACE,iBDkGgB;ECjGhB,oBAAA;EACA,wBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oCAAA;EACA,mCAAA;EACA,cAAA;EACA,kBAAA;AAgEJ;AA9DI;EAGE,wBAAA;EACA,yBAAA;AA8DN;AA3DI;EACE,oCAAA;EACA,oBAAA;EACA,wBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oCAAA;EACA,mCAAA;EACA,cAAA;EACA,kBAAA;AA6DN;AA3DM;EAGE,wBAAA;EACA,yBAAA;AA2DR;AAtDE;EACE,iBD6DiB;EC5DjB,oBAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;AAwDJ;AArDE;EACE,oBAAA;EACA,iBAAA;EACA,oCAAA;EACA,wBAAA;EACA,4CAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;AAuDJ;AArDI;EACE,mCAAA;EACA,UAAA;EACA,SAAA;EACA,qBAAA;AAuDN;AArDM;EACE,wCAAA;AAuDR;AApDM;EACE,cAAA;EACA,WAAA;AAsDR;AAnDI;EACE,mCAAA;EACA,sBAAA;EACA,SAAA;EACA,qBAAA;AAqDN;AApDM;EACE,wCAAA;AAsDR;AApDM;EACE,aAAA;EACA,WAAA;AAsDR;AAlDI;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,oCAAA;AAoDN;AAlDM;EACE,wCAAA;AAoDR;AAnDQ;EACE,iBAAA;EACA,2BAAA;AAqDV;AAlDQ;EACE,gBAAA;EACA,wBAAA;EACA,aAAA;EACA,qCAAA;AAoDV;AA/CQ;EACE,wCAAA;AAiDV;AA/CQ;EACE,wBAAA;EACA,aAAA;EACA,qCAAA;EACA,YAAA;AAiDV;AA5CI;EACE,yBAAA;EACA,oCAAA;EACA,kBAAA;EACA,YAAA;AA8CN;AA3CQ;EACE,gDAAA;AA6CV;;AApCA;EACE,wBAAA;AAuCF;;AApCA;EACE,oCAAA;EACA,yBAAA;EAEA,gBAAA;EACA,cAAA;EACA,gBAAA;AAsCF;;AAnCA;EACE,aAAA;EACA,mBAAA;EACA,qCAAA;EACA,2BAAA;EAEA,gBAAA;EACA,cAAA;AAqCF;;AAlCA;EACE,oCAAA;EAEA,gBAAA;EACA,cAAA;EACA,gBAAA;AAoCF;;AAhCE;EACE,2BAAA;EACA,iCAAA;EACA,gBAAA;EACA,mBAAA;AAmCJ;;AA/BA;EACE,gBAAA;EACA,kBAAA;AAkCF;AAhCE;EACE,kBAAA;EACA,OAAA;AAkCJ;;AA9BA;EACE,wCAAA;EACA,oCAAA;EACA,YAAA;EACA,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AAiCF;AA/BE;EACE,cAAA;EACA,mCAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AAiCJ;;AAjBA;EACE,aAAA;EACA,eAAA;AAoBF;AAnBE;EACE,kBAAA;AAqBJ;;AAJA;EACE,aAAA;EACA,oCAAA;EACA,mBAAA;EACA,wCAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;EACA,qBAAA;AAOF;AALE;EACE,oBAAA;AAOJ;AAJE;EACE,2BAAA;AAMJ;;AAFA;EACE,eAAA;EACA,oCAAA;EACA,eAAA;EACA,mCAAA;EACA,qBAAA;EACA,yBAAA;AAKF;AAHE;EACE,aAAA;EACA,eAAA;AAKJ;AAHI;EACE,oBAAA;AAKN;;AAAA;EACE,WAAA;AAGF","sourcesContent":[":root {\n\t//COLORS\n\t--color-light: #f4f9ff;\n\t--color-white: #ffffff;\n\n\t--color-primary: #1f68d6;\n\t--color-primary-2: #3b7ee3;\n\t--color-primary-3: #ccedff;\n\t--color-primary-4: #003c97;\n\t--color-primary-7: #c1daff;\n\t--color-primary-8: #97c1ff;\n\t--color-primary-9: #CCEDFF;\n\t--color-primary-10: #A8E1AE;\n\t--color-primary-11: #a1c4f9;\n\t--color-primary-12: #F5F5F5;\n\t--color-light-2: #E0E0E0;\n\n\n\t--color-error: #e12f2f;\n\t--color-success: #66b032;\n\t--color-green: #569755;\n\t--color-green-2: #92e391;\n\t--color-green-3: #d3eace;\n\t--color-yellow: #e7d788;\n\t--color-yellow-2: #ffc247;\n\t--color-yellow-3: #8f4f00;\n\t--color-light-red: #FFE8E8;\n\t--color-deep-red: #9f0000;\n\t--color-red: #c43c2d;\n\t--color-red-2: #af2415;\n\n\t--color-grey: #b3b3c5;\n\t--color-grey-2: #9898AB;\n\t--color-grey-3: #e0e9f3;\n\t--color-grey-4: #D1D1D1;\n\t--color-grey-5: #EBEBF5;\n\t--color-table-grey: #fafafc;\n\t--color-table-grey-1: #f4f4fc;\n\n\t--color-dark: #4a4a68;\n\t--color-dark-2: #1a1a42;\n\t--color-dark-3: #696365;\n\t--color-dark-4: #60607A;\n\t--color-dark-6: #2a2828;\n\n\t--color-admin: #112855;\n\t--color-admin-2: #071530;\n\t--color-admin-3: #020710;\n\n\t--color-disabled: #C0C0C0;\n\t--color-light-blue: #EBF2FF;\n\t--color-light-blue-2: #D4E5FF;\n\t--color-light-blue-3: #E7F3FE;\n\n\t--color-dark-yellow: #7E6E1F;\n\t--color-light-brown: #f4f5f6;\n\t--color-light-green: #E4FFEC;\n\t--color-light-yellow: #FFF5D7;\n\t--color-light-grey: #F3F3FF;\n\t--color-sell-main: #001432;\n\t--color-sell-2: #5F5F61;\n\n\t--color-moneyex-primary: #25C900;\n\t--color-moneyex-primary-2: #6bf04d;\n\t--color-moneyex-primary-3: #305627;\n\t--color-moneyex-primary-4: #0a2404;\n\n\n\n\t// FONT\n\t--default-font-size: 1.8rem;\n\t--default-font-h1: 6.4rem;\n\t--default-font-h2: 4rem;\n\t--default-font-h3: 3.2rem;\n\t--default-font-subtitle: 2.4rem;\n\t--default-font-medium: 1.6rem;\n\t--default-font-small: 1.4rem;\n\t--default-font-xsmall: 1.2rem;\n}\n\n//COLORS\n$color-light: #f4f9ff;\n$color-white: #ffffff;\n\n$color-primary: #1f68d6;\n$color-primary-2: #3b7ee3;\n$color-primary-3: #ccedff;\n$color-primary-4: #003c97;\n$color-primary-7: #c1daff;\n$color-primary-09: #CCEDFF;\n\n$color-error: #e12f2f;\n$color-success: #66b032;\n$color-green: #569755;\n$color-green-2: #92e391;\n$color-yellow: #e7d788;\n$color-light-red: #f7d1cd;\n\n$color-grey: #b3b3c5;\n$color-grey-2: #d1d1d1;\n$color-grey-3: #e0e9f3;\n$color-grey-4: #D1D1D1;\n\n$color-dark: #4a4a68;\n$color-dark-3: #696365;\n$color-dark-6: #2a2828;\n\n// FONT\n$default-font-size: 1.8rem;\n$default-font-h1: 6.4rem;\n$default-font-h2: 4rem;\n$default-font-h3: 3.2rem;\n$default-font-subtitle: 2.4rem;\n$default-font-small: 1.4rem;\n\n// SHADOWS\n$shadow-dark: 0 2rem 6rem rgba(0, 0, 0, 0.3);\n$shadow-light: 0 2rem 5rem rgba(0, 0, 0, 0.06);","@import \"./variables/variables\";\n\n.form {\n  display: block;\n\n  &__group:not(:last-child) {\n    margin-bottom: 1rem;\n  }\n\n  &__input {\n    font-size: $default-font-size;\n    font-family: inherit;\n    color: var(--color-dark);\n    padding-left: 2rem;\n    width: 100%;\n    height: 6rem;\n    border-radius: 1rem;\n    background-color: var(--color-white);\n    border: 1px solid var(--color-dark);\n    display: block;\n    margin-top: 0.5rem;\n\n    &:focus,\n    &:focus-visible,\n    &:focus-within {\n      color: var(--color-dark);\n      border: 1px solid $color-primary;\n    }\n\n    &_filter {\n      font-size: var(--default-font-small);\n      font-family: inherit;\n      color: var(--color-dark);\n      padding-left: 2rem;\n      width: 100%;\n      height: 4rem;\n      border-radius: 1rem;\n      background-color: var(--color-white);\n      border: 1px solid var(--color-dark);\n      display: block;\n      margin-top: 0.5rem;\n\n      &:focus,\n      &:focus-visible,\n      &:focus-within {\n        color: var(--color-dark);\n        border: 1px solid $color-primary;\n      }\n    }\n  }\n\n  &__label {\n    font-size: $default-font-small;\n    font-family: inherit;\n    padding-left: 2rem;\n    box-sizing: border-box;\n    width: 38rem;\n  }\n\n  &__calendar {\n    font-family: inherit;\n    font-size: 1.4rem;\n    background-color: var(--color-white);\n    color: var(--color-dark);\n    box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n    border-radius: 1rem;\n    border: none;\n    width: 25rem;\n    height: 27.5rem;\n    display: inline-block;\n    position: relative;\n    box-sizing: border-box;\n    padding: 5px;\n\n    & > :nth-child(3) {\n      background-color: var(--color-dark);\n      left: 1rem;\n      top: 1rem;\n      border-radius: 0.8rem;\n\n      &:hover {\n        background-color: var(--color-primary-4);\n      }\n\n      span::before {\n        right: -0.3rem;\n        top: 0.7rem;\n      }\n    }\n    & > :nth-child(4) {\n      background-color: var(--color-dark);\n      right: 1rem !important;\n      top: 1rem;\n      border-radius: 0.8rem;\n      &:hover {\n        background-color: var(--color-primary-4);\n      }\n      span::before {\n        left: -0.3rem;\n        top: 0.7rem;\n      }\n    }\n\n    & > :nth-child(5) {\n      width: 100%;\n      font-family: \"Montserrat\";\n      font-size: 1.4rem;\n      background-color: var(--color-light);\n\n      & > :nth-child(1) {\n        background-color: var(--color-primary-3);\n        & > :nth-child(1) {\n          font-size: 1.4rem;\n          color: var(--color-primary);\n        }\n\n        & > :nth-child(3) {\n          font-weight: 700;\n          color: var(--color-dark);\n          display: grid;\n          grid-template-columns: repeat(7, 1fr);\n        }\n      }\n\n      & > :nth-child(2) {\n        & > :nth-child(even) {\n          background-color: var(--color-primary-7);\n        }\n        & > * {\n          color: var(--color-dark);\n          display: grid;\n          grid-template-columns: repeat(7, 1fr);\n          height: 3rem;\n        }\n      }\n    }\n\n    & > :nth-child(6) {\n      font-family: \"Montserrat\";\n      font-size: var(--default-font-small);\n      position: absolute;\n      right: -85px;\n\n      & > :nth-child(1) {\n        & > * {\n          font-size: var(--default-font-xsmall) !important;\n        }\n      }\n    }\n  }\n}\n\n// When form is filled\n\n.filled {\n  color: var(--color-dark);\n}\n\n.error {\n  font-size: var(--default-font-small);\n  color: var(--color-error);\n  // padding-left: 2rem;\n  font-weight: 400;\n  margin: 1rem 0;\n  max-width: 38rem;\n}\n\n.note {\n  display: flex;\n  align-items: center;\n  font-size: var(--default-font-xsmall);\n  color: var(--color-primary);\n  // padding-left: 2rem;\n  font-weight: 400;\n  margin: 1rem 0;\n}\n\n.pageCount {\n  font-size: var(--default-font-small);\n  // padding-left: 2rem;\n  font-weight: 700;\n  margin: 1rem 0;\n  max-width: 38rem;\n}\n// Success\n.success {\n  &__h3 {\n    color: var(--color-success);\n    font-size: var(--default-font-h3);\n    font-weight: 700;\n    line-height: 3.5rem;\n  }\n}\n\n.iconAlign {\n  max-height: 6rem;\n  position: relative;\n\n  & > :nth-child(2) {\n    position: absolute;\n    left: 0;\n  }\n}\n\n.tag {\n  background-color: var(--color-primary-3);\n  font-size: var(--default-font-small);\n  height: 4rem;\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  width: 15rem;\n  margin-top: 1rem;\n  margin-right: 1rem;\n\n  &_close {\n    display: block;\n    background-color: var(--color-dark);\n    color: var(--color-white);\n    width: 16px;\n    height: 16px;\n    line-height: 16px;\n    text-align: center;\n    border-radius: 50%;\n  }\n}\n\n// .tags{\n//     margin: 20px auto;\n//     display: flex;\n//     flex-wrap: wrap;\n//     overflow: hidden;\n//     width: 70%;\n//     min-width: 80%;\n//     border: 1px rgb(173, 162, 162) solid;\n//     border-radius: 5px;\n//     color: black;\n// }\n\n.tags {\n  display: flex;\n  flex-wrap: wrap;\n  & > :not(:last-child) {\n    margin-right: 1rem;\n  }\n}\n\n// .single-tag{\n//     list-style: none;\n//     display: flex;\n//     align-items: center;\n//     margin: 7px 0 7px 14px;\n//     padding: 0 10px;\n//     padding-right: 5px;\n//     border: 1.5px solid #764abc;\n//     border-radius: 5px;\n//     white-space: nowrap;\n//     color: #764abc;\n// }\n\n.singleTag {\n  display: flex;\n  font-size: var(--default-font-small);\n  align-items: center;\n  background-color: var(--color-primary-3);\n  padding: 0.5rem;\n  border-radius: 0.5rem;\n  cursor: pointer;\n  margin-bottom: 0.5rem;\n\n  & > :not(:last-child) {\n    margin-right: 0.5rem;\n  }\n\n  &:hover {\n    color: var(--color-primary);\n  }\n}\n\n.suggestions {\n  padding: 0.5rem;\n  font-size: var(--default-font-small);\n  cursor: pointer;\n  background-color: var(--color-dark);\n  border-radius: 0.5rem;\n  color: var(--color-white);\n\n  &__all {\n    display: flex;\n    flex-wrap: wrap;\n\n    & > :not(:last-child) {\n      margin-right: 0.5rem;\n    }\n  }\n}\n\n.dateInput {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `MimaInput_form__HrJaF`,
	"form__group": `MimaInput_form__group__WVOmY`,
	"form__input": `MimaInput_form__input__r5iYU`,
	"form__input_filter": `MimaInput_form__input_filter__zDB96`,
	"form__label": `MimaInput_form__label__FIG4x`,
	"form__calendar": `MimaInput_form__calendar__BG5qm`,
	"filled": `MimaInput_filled__lg89T`,
	"error": `MimaInput_error__QkKJM`,
	"note": `MimaInput_note__rddKG`,
	"pageCount": `MimaInput_pageCount__q1trw`,
	"success__h3": `MimaInput_success__h3__1dGfk`,
	"iconAlign": `MimaInput_iconAlign__3NiB0`,
	"tag": `MimaInput_tag__HOPrF`,
	"tag_close": `MimaInput_tag_close__CPSWl`,
	"tags": `MimaInput_tags__JdTMp`,
	"singleTag": `MimaInput_singleTag__G0kUc`,
	"suggestions": `MimaInput_suggestions__aMe2F`,
	"suggestions__all": `MimaInput_suggestions__all__1BQjb`,
	"dateInput": `MimaInput_dateInput__JI0Z8`
};
export default ___CSS_LOADER_EXPORT___;
